module.exports = __webpack_public_path__ + "img/UTPIUT-4.6de7c9d8.jpg";